import { Driver } from './driver';
import { Address, Vehicle } from './vehicle';

export enum NoDriverReason {
    REPAIR = 'REPAIR',
    OTHER = 'OTHER'
}

export interface Reservation {
    id?: number;
    tenant_id: number;
    driver_id: number;
    vehicle_id: number;
    startTime: Date;
    endTime: Date;
    pickupLocation: Address;
    dropoffLocation: Address;
    noDriverReason: NoDriverReason;
    driver: Partial<Driver>;
    vehicle: Partial<Vehicle>;
}
